import { Choice, Section } from "@/components/settings/primitives";
import { useUpdateSettings } from "@/hooks/queries";
import { VoiceSection } from "@/components/settings/VoiceSection";

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

export function PreferencesSection({ me }) {
  const update = useUpdateSettings();
  const s = me.settings;
  return (
    <div className="space-y-4">
      <Section title="Response style" description="How much detail ChatSleek puts into its answers." testId="settings-response-style-section">
        <Choice
          value={s.response_style}
          onChange={(v) => update.mutate({ response_style: v })}
          options={[{ value: "concise", label: "Concise" }, { value: "balanced", label: "Balanced" }, { value: "detailed", label: "Detailed" }]}
          testIdPrefix="settings-response-style"
        />
      </Section>
      <Section title="Send key" description="Choose how you send a message. The other combination adds a new line." testId="settings-send-key-section">
        <Choice
          value={s.send_key}
          onChange={(v) => update.mutate({ send_key: v })}
          options={[{ value: "enter", label: "Enter" }, { value: "mod_enter", label: isMac ? "⌘ + Enter" : "Ctrl + Enter" }]}
          testIdPrefix="settings-send-key"
        />
      </Section>
      <VoiceSection me={me} />
    </div>
  );
}
